import { ButtonColors, ButtonVariants } from '@/components/atoms/button/index';
import { RichTextFieldStrapiProps } from '@/components/atoms/richTextField/RichTextFieldSB';
import { BlockComponentModel } from '@/components/cms/types/blok-component';
import { SECTION_NAMES } from '@/components/integrations/trackingScripts/constants';

import PricingCards, {
  PricingCardsProps,
  ProductPriceTypes,
  ProductSequantialTypes,
} from '@/features/cards/PricingCards/PricingCards';
import { FeatureListStrapiProps } from '@/features/shared/FeatureListStrapi';
import { Product } from '@/features/types/product';
import {
  BlockHeader,
  BlockHeaderContent,
} from '@/features/utils/BlockHeaderContent';
import { BlockWrapper } from '@/features/utils/BlockWrapper';

export type PricingCardsFeatureListStrapiProps = FeatureListStrapiProps & {
  title?: string;
  productType: Product;
};

export interface PricingCardsFeatureListStrapi {
  featuresList: {
    data: Array<{
      id: number;
      attributes: PricingCardsFeatureListStrapiProps;
    }>;
  };
}

export type PricingCardContactSalesProps = {
  id: string;
  attributes: {
    heading?: RichTextFieldStrapiProps['block'];
    description?: RichTextFieldStrapiProps['block'];
    button?: {
      text?: string;
      variant?: ButtonVariants;
      color: ButtonColors;
      link?: string;
    };
    disclaimer?: RichTextFieldStrapiProps['block'];
    productType: Product;
    productPriceCategory: ProductPriceTypes | 'all';
    productSequence: ProductSequantialTypes | 'all';
  };
};

type PricingCardsStrapiProps = {
  header?: BlockHeader;
  contactSalesCards?: { data: PricingCardContactSalesProps[] };
  pricing_cards: {
    data: {
      id: string;
      attributes: PricingCardsProps['cards'][number];
    }[];
  };
  features_references?: PricingCardsFeatureListStrapi['featuresList'];
};

export function PricingCardsStrapi({
  block,
  ...rest
}: BlockComponentModel<PricingCardsStrapiProps>) {
  const { header, pricing_cards, features_references } = block;

  const formattedCards = pricing_cards.data.map(({ attributes: card }) => card);

  // TODO temp solution for china. Issues with database having duplicates from EN language but not visible in UI, Strapi? dafuk?
  const distinctPricingCards = formattedCards.reduce((acc, card) => {
    if (
      !acc.find(
        (c) =>
          c.productPriceCategory === card.productPriceCategory &&
          c.productType === card.productType &&
          c.productSequence === card.productSequence &&
          c.pricingCard.title === card.pricingCard.title &&
          c.pricingCard.priceTotal === card.pricingCard.priceTotal
      )
    ) {
      acc.push(card);
    }
    return acc;
  }, [] as PricingCardsProps['cards']);

  return (
    <BlockWrapper {...rest} theme={header?.theme?.themeKey}>
      <div data-tracker-section={SECTION_NAMES.PRICING_CARDS}>
        <BlockHeaderContent {...header} classNames={{ header: '!mb-9' }}>
          <PricingCards
            cards={distinctPricingCards}
            features={features_references}
            contactSalesCards={block.contactSalesCards}
          />
        </BlockHeaderContent>
      </div>
    </BlockWrapper>
  );
}
